import request from '@/utils/request'

// 创建课程：
const createLive = (params) => {
  return request({
    url: '/admin/live/create/v100',
    method: 'post',
    data: params
  })
}

// 直播列表：
const searchLive = (params) => {
  return request({
    url: '/admin/live/list/v100',
    method: 'post',
    data: params
  })
}

// 删除直播：
const deletedLive = (id) => {
  return request({
    url: `/admin/live/deleted/v100?liveId=${id}`,
    method: 'get'
  })
}

// 获取当前机构所以教室：
const liveListClassRoomBySchoolId = (params) => {
  return request({
    url: '/admin/classroom/listClassRoomBySchoolId/v100',
    method: 'get',
    params
  })
}

// 当前机构教师列表：
const liveListTeacherBySchoolId = (params) => {
  return request({
    url: '/admin/teacherManage/listTeacherBySchoolId/v100',
    method: 'get',
    params
  })
}

// 直播列表：
const searchLiveByPage = (params) => {
  return request({
    url: '/admin/live/searchLiveByPage',
    method: 'post',
    data: params
  })
}

// 获取视频信息：
const getVideoInfo = (params) => {
  return request({
    url: '/admin/live/getVideoInfo',
    method: 'post',
    params
  })
}

export default {
  createLive,
  searchLive,
  deletedLive,
  liveListClassRoomBySchoolId,
  liveListTeacherBySchoolId,
  searchLiveByPage,
  getVideoInfo
}
